S.video = {
    config: {
        videoId: null,
        videoType: 'youtube',
    },
    elements: {
        $videoWrapper: null,
        $video: null,
        $playButton: null,
    },

    /** @var {String} concatedSrc */
    concatedSrc: null,

    /** @var {String} allowParam */
    allowParam: '',

    init()
    {},

    /**
     * in the start() function all modules instances are initialized
     */
    start()
    {
        // get needed url
        this.getUrl();

        // add logic for loop
        // const $duplicateSlide = this.$module.closest('.swiper-wrapper').find(`.swiper-slide-duplicate`).filter(`[data-id="${this.config.videoId}"]`);
        // if ($duplicateSlide.length) {
        //
        //     for (const duplicate of $duplicateSlide) {
        //
        //         $(duplicate).find('.m-icon').on('click', () => {
        //         })
        //     }
        // }

        this.elements.$playButton.on('click', () =>
        {
            this.elements.$videoWrapper.addClass('m-play');

            // 1.5 second visibility animation for a smoother transition
            this.handleIframe();

            S.delayed(`video-play-delay-${this.id}`, 500, () =>
            {
                this.elements.$video.removeClass('is-hidden');
            });
        });
    },
    /**
     * concat needed url
     */
    getUrl()
    {
        // concat video url string
        switch (this.config.videoType)
        {
            case 'vimeo':
                // dnt = Do Not Track
                this.concatedSrc = `https://player.vimeo.com/video/${this.config.videoId}?dnt=1&autoplay=1`;
                this.allowParam = 'autoplay; fullscreen';
                break;
            case 'youtube':
                this.concatedSrc = `https://www.youtube-nocookie.com/embed/${this.config.videoId}?autoplay=1&mute=1`;
                break;
            default:
                this.concatedSrc = false;
        }
    },
    /**
     * set the iframe together and append it
     * - if we dont do this, it wont autoplay when we want it
     */
    handleIframe()
    {
        // set iframe
        const iframeHTML = `<iframe class="m-video" width="100%" height="100%" src="${this.concatedSrc}" allow="${this.allowParam}" frameborder="0" allowfullscreen></iframe>`;
        // append it and let it autoplay
        this.elements.$video.append(iframeHTML);
    },
};
